import styled from 'styled-components'

export const SkeletonRoot = styled.div`
    display: flex;
    flex-direction: column;
    gap: 18px;
`;
export const FilterSkeletons = styled.div`
    padding-bottom: 30px;
    border-bottom: 1px solid ${({ theme }) => theme.palette.colors.borderStrong};
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
`;
export const ResultsSkeleton = styled.div``;
export const ResultSkeleton = styled.div`
    min-height: 150px;
    padding: 28px 4px;
    border-bottom: 1px solid ${({ theme }) => theme.palette.colors.borderSoft};
    display: flex;
    flex-direction: column;
    gap: 14px;
`;
